export const getHeaders = (token: string | null) => {
  return {
    headers: {
      Authorization: `Bearer ${ token }`,
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }
  };
};
